import React, { useState, useRef, useEffect } from 'react';

const CategoryManager = ({ categories, initialServiceInstances = [], onSelectionsChange }) => {
    const [serviceInstances, setServiceInstances] = useState(initialServiceInstances);
    const [openCategoryId, setOpenCategoryId] = useState(null);
    const categoryRefs = useRef({});

    const toggleService = (serviceId) => {
        const newSelectedServiceInstances = [
            ...serviceInstances.filter(si => si.serviceId !== serviceId)
        ];

        let result = newSelectedServiceInstances;

        if (!isServiceSelected(serviceId)) {
            result.push({
                serviceId
            });
        }

        setServiceInstances(result);
        onSelectionsChange(result);
    };

    const isServiceSelected = (serviceId) => {
        return serviceInstances.some(si => si.serviceId === serviceId);
    };

    const isServiceRemote = (serviceId) => {
        const si = serviceInstances.filter(si => si.serviceId === serviceId);
        if (si.length === 0) return false;
        return si[0].isRemote;
    };

    const toggleRemote = (serviceId) => {
        const newServiceInstances = [
            ...serviceInstances.map(si => {
                if (si.serviceId === serviceId) {
                    return {...si, isRemote: !si.isRemote}
                }
                return si;
            })
        ]

        setServiceInstances(newServiceInstances);
        onSelectionsChange(newServiceInstances);
    }

    const countSelected = (category) => {
        let count = 0;
        category.services.forEach(s => { if (isServiceSelected(s.id)) count++; });
        category.subCategories.forEach(sc => {
            sc.services.forEach(s => { if (isServiceSelected(s.id)) count++; });
        });
        return count;
    };

    const countSubSelected = (subCategory) => {
        let count = 0;
        subCategory.services.forEach(s => { if (isServiceSelected(s.id)) count++; });
        return count;
    };

    const serviceItem = (service, category, subCategory) => {
        const selected = isServiceSelected(service.id);
        const remote = isServiceRemote(service.id);

        return (
            <div key={service.id + ',' + category.id + (subCategory ? ',' + subCategory.id : '')}
                 className="service-tree__pill-item">
                <label className={`service-tree__checkbox ${selected ? 'service-tree__checkbox--active' : ''}`}>
                    <input
                        type="checkbox"
                        checked={selected}
                        onChange={() => toggleService(service.id)}
                    />
                    <i className={`fa-solid ${selected ? 'fa-circle-check' : 'fa-circle'}`}></i>
                    <span>{service.name}</span>
                </label>
                {selected && (
                    <label className={`service-tree__remote-check ${remote ? 'service-tree__remote-check--active' : ''}`}>
                        <input
                            type="checkbox"
                            checked={remote}
                            onChange={() => toggleRemote(service.id)}
                        />
                        <i className={`fa-solid ${remote ? 'fa-circle-check' : 'fa-circle'}`}></i>
                        <span>Digitalt</span>
                    </label>
                )}
            </div>
        );
    };

    return (
        <div className="service-tree service-tree--editor">
            {categories && categories.sort((a, b) => a && b && a.name.localeCompare(b.name)).map(category => {
                const hasContent = (category?.subCategories?.length || category?.services?.length > 0) > 0;
                if (!hasContent) return null;

                const selectedCount = countSelected(category);

                const isOpen = selectedCount > 0 || openCategoryId === category.id;

                return (
                    <details
                        key={category.id}
                        className={`service-tree__category ${selectedCount === 0 ? 'service-tree__category--inactive' : ''}`}
                        open={isOpen}
                        ref={el => categoryRefs.current[category.id] = el}
                        onToggle={(e) => {
                            if (e.target.open && selectedCount === 0) {
                                setOpenCategoryId(category.id);
                            } else if (!e.target.open && openCategoryId === category.id) {
                                setOpenCategoryId(null);
                            }
                        }}
                    >
                        <summary className="service-tree__category-header">
                            <i className="fa-solid fa-chevron-right chevron"></i>
                            <span className="btn btn-primary btn-category">
                                <i className="fa-solid fa-tag"></i> {category.name}
                            </span>
                            {selectedCount > 0 && (
                                <span className="category-count">{selectedCount}</span>
                            )}
                        </summary>
                        <div className="service-tree__category-body">
                            {category.services.length > 0 && (
                                <div className="service-tree__pills">
                                    {category.services.sort((a, b) => a && b && a.name.localeCompare(b.name)).map(service => serviceItem(service, category, null))}
                                </div>
                            )}
                            {category.subCategories.map(subCategory => {
                                if (subCategory.services.length === 0) return null;
                                const subSelected = countSubSelected(subCategory);
                                return (
                                <details key={subCategory.id} className={`service-tree__subcategory ${subSelected === 0 ? 'service-tree__subcategory--inactive' : ''}`} open>
                                    <summary className="service-tree__subcategory-header">
                                        <i className="fa-solid fa-chevron-right chevron"></i>
                                        <span className="btn btn-primary btn-sub-category">
                                            <i className="fa-solid fa-tags"></i> {subCategory.name}
                                        </span>
                                        {subSelected > 0 && (
                                            <span className="subcategory-count">{subSelected}</span>
                                        )}
                                    </summary>
                                    <div className="service-tree__subcategory-body">
                                        <div className="service-tree__pills">
                                            {subCategory.services.sort((a, b) => a && b && a.name.localeCompare(b.name)).map(service => serviceItem(service, category, subCategory))}
                                        </div>
                                    </div>
                                </details>
                                );
                            })}
                        </div>
                    </details>
                );
            })}
        </div>
    );
};

export default CategoryManager;
